import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { processType } from '../ToleranceRange/ToleranceRange.component';
import { getProcessLabel } from '../../../../utils/assessmentSessionProcess';

export const InactiveProcessBadge: React.FC<{ processType: processType }> = ({ processType }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'left',
        height: 40,
        paddingTop: '1px',
        paddingBottom: '1px',
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'center',
        color: '#2C2D3E',
        background: 'rgba(53, 96, 255, 0.1)',
        borderRadius: '4px',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
      }}
    >
      <InfoOutlinedIcon sx={{ color: '#3560FF', fontSize: 18, marginRight: 2, marginLeft: 3 }} />W tej grupie zadań{' '}
      {getProcessLabel(processType).label.toLowerCase()} nie jest wymagany
    </div>
  );
};
